export interface OpeningHours {
  day: string;
  hours: string;
  isOpen: boolean;
}

export interface VenueFullDetail {
  id: string;
  name: string;
  category: string;
  categorySlug: string;
  rating: number;
  reviews: number;
  distanceKm: number;
  coverImage: string;
  gallery: string[];
  address: string;
  district: string;
  phone: string;
  website: string;
  email: string;
  isSponsored: boolean;
  isEditorPick: boolean;
  isOpen: boolean;
  description: string;
  longDescription: string;
  tags: string[];
  lat: number;
  lng: number;
  openingHours: OpeningHours[];
  priceRange: string;
  campaignId: string | null;
  relatedVenueIds: string[];
}

export const venueDetails: VenueFullDetail[] = [
  {
    id: "ulu-cami",
    name: "Ulu Cami",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.9,
    reviews: 3240,
    distanceKm: 1.2,
    coverImage: "https://public.readdy.ai/ai/img_res/7cb3ecb252fa8aaed2e31e6e8e8505c3.jpg",
    gallery: [
      "https://readdy.ai/api/search-image?query=Ulu%20Cami%20interior%20grand%20Ottoman%20mosque%20Bursa%20calligraphy%20walls%20dome%20ceiling%20ornate%20ancient%20artistic%20stone&width=800&height=600&seq=vd_ulucami_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Ulu%20Cami%20Bursa%20mosque%20courtyard%20fountain%20pool%20stone%20arches%20daytime%20serene%20holy%20atmosphere&width=800&height=600&seq=vd_ulucami_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Ulu%20Cami%20minaret%20Bursa%20Ottoman%20architecture%20stone%20ancient%20city%20skyline%20blue%20sky%20exterior%20close&width=800&height=600&seq=vd_ulucami_g3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Ulu%20Cami%20Bursa%20mosque%20interior%20prayer%20hall%20carpeted%20floor%20wooden%20pulpit%20historical%20atmosphere%20light&width=800&height=600&seq=vd_ulucami_g4&orientation=landscape",
    ],
    address: "Atatürk Cad., Osmangazi, Bursa",
    district: "Osmangazi",
    phone: "+90 224 221 0000",
    website: "",
    email: "",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "20 kubbesi ve muhteşem hat yazıları ile Osmanlı mimarisinin en önemli eserlerinden biri. İçindeki şadırvan Bursa'nın simgesidir.",
    longDescription: "Ulu Cami, 1399-1421 yılları arasında Sultan I. Mehmed tarafından inşa ettirilen ve Bursa'nın simgesi haline gelmiş büyük bir Osmanlı camisidir. 20 kubbeyi destekleyen 12 fili payesiyle dikkat çekici mimari anlayışıyla Osmanlı mimarisinin en önemli örneklerinden biri olarak kabul edilir. Cami içindeki dev şadırvan, özgünlüğünü koruyan nadir tarihi eserlerden biridir. Duvarları ve tavanı süsleyen 192 adet hat yazısı, İslam sanatının en nadide örnekleri arasında yer almaktadır. UNESCO tarafından dünya mirası listesine alınması için aday gösterilen yapı, her yıl binlerce yerli ve yabancı ziyaretçi tarafından gezilmektedir.",
    tags: ["Cami", "Mimari", "UNESCO", "Ücretsiz", "Osmanlı"],
    lat: 40.18352,
    lng: 29.06098,
    openingHours: [
      { day: "Pazartesi", hours: "07:00 – 22:00", isOpen: true },
      { day: "Salı", hours: "07:00 – 22:00", isOpen: true },
      { day: "Çarşamba", hours: "07:00 – 22:00", isOpen: true },
      { day: "Perşembe", hours: "07:00 – 22:00", isOpen: true },
      { day: "Cuma", hours: "07:00 – 22:00", isOpen: true },
      { day: "Cumartesi", hours: "07:00 – 22:00", isOpen: true },
      { day: "Pazar", hours: "07:00 – 22:00", isOpen: true },
    ],
    priceRange: "Ücretsiz",
    campaignId: null,
    relatedVenueIds: ["yesil-cami", "osman-gazi-turbesi", "hanlar-bolgesi", "muradiye-camii"],
  },
  {
    id: "yesil-cami",
    name: "Yeşil Cami",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 2100,
    distanceKm: 2.1,
    coverImage: "https://readdy.ai/api/search-image?query=Yesil%20Cami%20Green%20Mosque%20Bursa%20Ottoman%20turquoise%20tiles%20minaret%20exterior%20stone%20architecture%20ancient%20Islamic%20heritage%20wide%20dramatic%20angle&width=1400&height=600&seq=vd_yesil_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Yesil%20Cami%20interior%20turquoise%20tile%20panels%20Bursa%20mosque%20beautiful%20ornate%20Islamic%20art%20ceiling&width=800&height=600&seq=vd_yesil_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Green%20Mosque%20Bursa%20exterior%20stone%20portal%20entrance%20carved%20marble%20Ottoman%20heritage&width=800&height=600&seq=vd_yesil_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Yesil%20Cami%20courtyard%20view%20minaret%20sky%20Bursa%20Ottoman%20architecture%20peaceful&width=800&height=600&seq=vd_yesil_g3&orientation=landscape",
    ],
    address: "Yeşil Mah., Yıldırım, Bursa",
    district: "Yıldırım",
    phone: "+90 224 327 0000",
    website: "",
    email: "",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Türk-İslam mimarisinin şaheseri. Türkuaz çinileri ve zarif minaresiyle Bursa'nın simge yapısı.",
    longDescription: "Yeşil Cami, 15. yüzyılda Sultan Çelebi Mehmed tarafından inşa ettirilen ve adını dışını süsleyen türkuaz yeşili çinilerden alan muhteşem bir Osmanlı camisidir. Cami, mimarisi ve süslemeleriyle Türk-İslam sanatının zirvesini temsil eder. İç mekanda yer alan çini panolar ve bezemelerin rengi ve kalitesi bugün hâlâ benzersizliğini korumaktadır. Yeşil Cami'nin hemen karşısında yer alan Yeşil Türbe ise Sultan'ın türbesini barındırmaktadır. Bursa'nın en çok ziyaret edilen tarihi yapılarından biri olan cami, dünya genelinde Osmanlı mimarisinin simgesi olarak tanınmaktadır.",
    tags: ["Cami", "Çini", "Mimari", "Ücretsiz", "Osmanlı"],
    lat: 40.18128,
    lng: 29.07305,
    openingHours: [
      { day: "Pazartesi", hours: "08:00 – 19:00", isOpen: true },
      { day: "Salı", hours: "08:00 – 19:00", isOpen: true },
      { day: "Çarşamba", hours: "08:00 – 19:00", isOpen: true },
      { day: "Perşembe", hours: "08:00 – 19:00", isOpen: true },
      { day: "Cuma", hours: "08:00 – 19:00", isOpen: true },
      { day: "Cumartesi", hours: "08:00 – 19:00", isOpen: true },
      { day: "Pazar", hours: "08:00 – 19:00", isOpen: true },
    ],
    priceRange: "Ücretsiz",
    campaignId: null,
    relatedVenueIds: ["yesil-turbe", "ulu-cami", "muradiye-camii", "cumalikizik-koy"],
  },
  {
    id: "yesil-turbe",
    name: "Yeşil Türbe",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 1980,
    distanceKm: 2.3,
    coverImage: "https://readdy.ai/api/search-image?query=Yesil%20Turbe%20Green%20Mausoleum%20Bursa%20ornate%20turquoise%20tiles%20geometric%20patterns%20Ottoman%20exterior%20dramatic%20sky%20ancient&width=1400&height=600&seq=vd_yesilturbe_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Green%20Mausoleum%20Bursa%20interior%20tiles%20sarcophagus%20ornate%20Islamic%20geometric%20art%20serene%20holy%20atmosphere&width=800&height=600&seq=vd_yesilturbe_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Yesil%20Turbe%20facade%20exterior%20tiles%20close%20up%20detail%20turquoise%20green%20Ottoman%20ceramic%20Bursa&width=800&height=600&seq=vd_yesilturbe_g2&orientation=landscape",
    ],
    address: "Yeşil Mah., Yıldırım, Bursa",
    district: "Yıldırım",
    phone: "+90 224 327 1111",
    website: "",
    email: "",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "6 asırdır değişmeyen turkuaz çinileriyle nefes kesen Osmanlı türbesi. Sultan Mehmed I burada yatmaktadır.",
    longDescription: "Yeşil Türbe, 1421 yılında hayatını kaybeden Osmanlı Sultanı I. Mehmed için inşa edilmiştir. Adını dış cephesini kaplayan parlak yeşil çinilerden almaktadır. Sekizgen planlı türbenin içi de zengin çini süslemelerle bezelidir. Sultan'ın zarif sandukası, renkli camlardan süzülen ışıkla aydınlanan iç mekânın odak noktasıdır. Hemen karşısındaki Yeşil Cami ile birlikte 15. yüzyılın başlarında yapılmış bu iki yapı, Türk-İslam mimarisinin başyapıtlarını oluşturmaktadır. Türbe, hafta içi ve hafta sonu ücretsiz gezilebilmektedir.",
    tags: ["Türbe", "Çini", "Tarih", "Ücretsiz", "Osmanlı"],
    lat: 40.18168,
    lng: 29.07328,
    openingHours: [
      { day: "Pazartesi", hours: "08:00 – 18:00", isOpen: true },
      { day: "Salı", hours: "08:00 – 18:00", isOpen: true },
      { day: "Çarşamba", hours: "08:00 – 18:00", isOpen: true },
      { day: "Perşembe", hours: "08:00 – 18:00", isOpen: true },
      { day: "Cuma", hours: "08:00 – 18:00", isOpen: true },
      { day: "Cumartesi", hours: "08:00 – 18:00", isOpen: true },
      { day: "Pazar", hours: "08:00 – 18:00", isOpen: true },
    ],
    priceRange: "Ücretsiz",
    campaignId: null,
    relatedVenueIds: ["yesil-cami", "osman-gazi-turbesi", "bursa-muzesi"],
  },
  {
    id: "osman-gazi-turbesi",
    name: "Osman Gazi Türbesi",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.7,
    reviews: 1560,
    distanceKm: 1.8,
    coverImage: "https://readdy.ai/api/search-image?query=Osman%20Gazi%20Tomb%20Bursa%20Ottoman%20dynasty%20founder%20mausoleum%20ancient%20stone%20historical%20landmark%20majestic%20architecture%20dramatic%20lighting%20wide%20view&width=1400&height=600&seq=vd_osmangazi_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Osman%20Gazi%20mausoleum%20interior%20ornate%20sarcophagus%20Ottoman%20royal%20tomb%20Bursa%20serene%20light%20atmosphere&width=800&height=600&seq=vd_osmangazi_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Tophane%20park%20Bursa%20city%20view%20panorama%20Ottoman%20walls%20ancient%20stone%20fortress%20evening%20light&width=800&height=600&seq=vd_osmangazi_g2&orientation=landscape",
    ],
    address: "Tophane, Osmangazi, Bursa",
    district: "Osmangazi",
    phone: "+90 224 220 0000",
    website: "",
    email: "",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Osmanlı Devleti'nin kurucusu Osman Gazi'nin türbesi. İmparatorluğun başlangıcını hissedebileceğiniz manevi bir mekan.",
    longDescription: "Osman Gazi Türbesi, 1280 yılında Söğüt'te kurulan Osmanlı Devleti'nin ilk hükümdarı Osman Gazi'nin mezarıdır. Tophane Parkı içinde yer alan bu anıtsal yapı, Bursa'nın fethinden sonra Osmanlı hanedanının önem verdiği şehrin en kutsal alanlarından biri olmuştur. Yanında oğlu Orhan Gazi'nin türbesi de bulunmaktadır. Türbenin etrafındaki Tophane Parkı, şehrin panoramik manzarasını sunan en güzel kamusal alanlarından biridir. Her yıl on binlerce ziyaretçi bu manevi mekânı ziyaret etmektedir.",
    tags: ["Türbe", "Osmanlı", "Tarih", "Ücretsiz"],
    lat: 40.18587,
    lng: 29.05814,
    openingHours: [
      { day: "Pazartesi", hours: "08:00 – 18:00", isOpen: true },
      { day: "Salı", hours: "08:00 – 18:00", isOpen: true },
      { day: "Çarşamba", hours: "08:00 – 18:00", isOpen: true },
      { day: "Perşembe", hours: "08:00 – 18:00", isOpen: true },
      { day: "Cuma", hours: "08:00 – 18:00", isOpen: true },
      { day: "Cumartesi", hours: "08:00 – 18:00", isOpen: true },
      { day: "Pazar", hours: "08:00 – 18:00", isOpen: true },
    ],
    priceRange: "Ücretsiz",
    campaignId: null,
    relatedVenueIds: ["ulu-cami", "bursa-kalesi", "hanlar-bolgesi"],
  },
  {
    id: "hanlar-bolgesi",
    name: "Hanlar Bölgesi",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 2890,
    distanceKm: 0.9,
    coverImage: "https://readdy.ai/api/search-image?query=Bursa%20covered%20bazaar%20hans%20Ottoman%20caravanserai%20historic%20stone%20arcade%20market%20traders%20ancient%20commercial%20district%20warm%20light%20grand%20view&width=1400&height=600&seq=vd_hanlar_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Koza%20Han%20Bursa%20silk%20market%20Ottoman%20courtyard%20ancient%20stone%20arches%20fountain%20center%20historic%20bazaar%20warm%20afternoon%20light&width=800&height=600&seq=vd_hanlar_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bursa%20bedesten%20historic%20market%20interior%20stone%20vaulted%20ceiling%20shops%20textiles%20artifacts%20ancient%20atmosphere&width=800&height=600&seq=vd_hanlar_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bursa%20Ottoman%20han%20caravanserai%20carved%20stone%20doorway%20entrance%20historical%20architecture%20detail%20Turkey%20heritage&width=800&height=600&seq=vd_hanlar_g3&orientation=landscape",
    ],
    address: "Kapalı Çarşı Çevresi, Osmangazi, Bursa",
    district: "Osmangazi",
    phone: "",
    website: "",
    email: "",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "15. yüzyıldan kalma tarihi hanlar, kervansaraylar ve el sanatları atölyeleri. Osmanlı ticaret hayatının yaşayan müzesi.",
    longDescription: "Hanlar Bölgesi, Bursa'nın kalbi sayılan ve birden fazla tarihi hanın, bedestenin ve çarşının bir araya geldiği açık hava müzesidir. Koza Han, Fidan Han, Pirinç Han ve Emir Han bu bölgenin öne çıkan yapılarıdır. 15. yüzyılda ipek ticaretinin merkezi olan bu bölge, günümüzde hâlâ aktif bir ticaret alanı olma özelliğini korumaktadır. El dokuması kumaşlardan tarihi eserler mağazalarına kadar geniş bir alışveriş seçeneği sunan bölge, fotoğraf çekimi için de mükemmel bir atmosfer sunmaktadır. Koza Han'ın avlusunda oturup çay içmek, Bursa ziyaretinin vazgeçilmez ritüellerinden biridir.",
    tags: ["Çarşı", "Han", "Alışveriş", "Kültür", "İpek"],
    lat: 40.18255,
    lng: 29.06000,
    openingHours: [
      { day: "Pazartesi", hours: "09:00 – 19:00", isOpen: true },
      { day: "Salı", hours: "09:00 – 19:00", isOpen: true },
      { day: "Çarşamba", hours: "09:00 – 19:00", isOpen: true },
      { day: "Perşembe", hours: "09:00 – 19:00", isOpen: true },
      { day: "Cuma", hours: "09:00 – 19:00", isOpen: true },
      { day: "Cumartesi", hours: "09:00 – 19:00", isOpen: true },
      { day: "Pazar", hours: "Kapalı", isOpen: false },
    ],
    priceRange: "Ücretsiz",
    campaignId: null,
    relatedVenueIds: ["kapali-carsi", "ulu-cami", "nilüfer-imareti"],
  },
  {
    id: "kebapci-iskender",
    name: "Kebapçı İskender",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.8,
    reviews: 4120,
    distanceKm: 0.8,
    coverImage: "https://readdy.ai/api/search-image?query=Iskender%20kebab%20restaurant%20Bursa%20original%20historic%20exterior%20stone%20building%20famous%20landmark%20entrance%20traditional%20facade%20warm%20evening&width=1400&height=600&seq=vd_iskender_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=iskender%20kebab%20dish%20plated%20traditional%20Turkish%20food%20grilled%20lamb%20pide%20tomato%20sauce%20butter%20presentation%20restaurant%20table&width=800&height=600&seq=vd_iskender_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kebapci%20Iskender%20restaurant%20interior%20historic%20Bursa%20warm%20traditional%20wooden%20decor%20dining%20room&width=800&height=600&seq=vd_iskender_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=iskender%20kebap%20meat%20skewer%20preparation%20traditional%20Turkish%20kitchen%20cooking%20chef%20authentic&width=800&height=600&seq=vd_iskender_g3&orientation=landscape",
    ],
    address: "Atatürk Cad. 60, Osmangazi, Bursa",
    district: "Osmangazi",
    phone: "+90 224 221 4615",
    website: "www.iskender.com.tr",
    email: "info@iskender.com.tr",
    isSponsored: true,
    isEditorPick: true,
    isOpen: true,
    description: "1867'de icat edilen orijinal İskender Kebap'ın beşiği. Aynı aile, aynı tarif, 157 yıldır.",
    longDescription: "Kebapçı İskender, 1867 yılında İskender Efendi tarafından icat edilen ve tüm dünyaya yayılan İskender Kebap'ın orijinal mekanıdır. Dilimlenmiş kuzu eti, pide ekmeği, domates sosu ve tereyağı kombinasyonuyla hazırlanan bu eşsiz lezzet, 6. nesil tarafından aynı orijinal tarife sadık kalınarak sunulmaktadır. Bursa'nın en prestijli ve tanınan restoranlarından biri olan mekan, yıl boyunca hem yerli hem yabancı ziyaretçilere hizmet vermektedir. Rezervasyon yapılması önerilmektedir. Restoranın aynı adres üzerindeki orijinal şubesi, defalarca kopyalanan ancak hiç aşılamayan lezzetiyle ziyaretçilerini ağırlamaya devam etmektedir.",
    tags: ["İskender", "Kebap", "Tarihi", "Öğle", "Orijinal"],
    lat: 40.18350,
    lng: 29.06130,
    openingHours: [
      { day: "Pazartesi", hours: "11:00 – 22:00", isOpen: true },
      { day: "Salı", hours: "11:00 – 22:00", isOpen: true },
      { day: "Çarşamba", hours: "11:00 – 22:00", isOpen: true },
      { day: "Perşembe", hours: "11:00 – 22:00", isOpen: true },
      { day: "Cuma", hours: "11:00 – 23:00", isOpen: true },
      { day: "Cumartesi", hours: "11:00 – 23:00", isOpen: true },
      { day: "Pazar", hours: "11:00 – 22:00", isOpen: true },
    ],
    priceRange: "₺₺",
    campaignId: null,
    relatedVenueIds: ["iskenderoglu", "haci-bey", "pideciler-carsisi", "cumalikizik-sofrasi"],
  },
  {
    id: "extrempark",
    name: "Extrempark Bursa",
    category: "Eğlence",
    categorySlug: "entertainment",
    rating: 4.8,
    reviews: 1820,
    distanceKm: 8.2,
    coverImage: "https://readdy.ai/api/search-image?query=Extrempark%20adventure%20park%20mountain%20Uludag%20Turkey%20zipline%20sled%20rope%20aerial%20panoramic%20wide%20dramatic%20hero%20shot%20summer%20outdoor&width=1400&height=600&seq=vd_extrempark_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=mountain%20sled%20ride%20alpine%20coaster%20Extrempark%20Bursa%20Turkey%20summer%20speed%20fun%20thrill%20outdoor%20adventure&width=800&height=600&seq=vd_extrempark_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=zipline%20adventure%20forest%20Turkey%20outdoor%20summer%20activity%20extreme%20sports%20mountain%20aerial%20view%20people%20fun&width=800&height=600&seq=vd_extrempark_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=giant%20swing%20mountain%20viewpoint%20panoramic%20Bursa%20Turkey%20adrenaline%20outdoor%20adventure%20activity%20sky&width=800&height=600&seq=vd_extrempark_g3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=rope%20course%20obstacle%20adventure%20park%20Turkey%20forest%20outdoor%20summer%20family%20children%20activity%20fun&width=800&height=600&seq=vd_extrempark_g4&orientation=landscape",
    ],
    address: "Odunluk, Atatürk Kent Ormanı No:17, 16110 Nilüfer/Bursa",
    district: "Nilüfer",
    phone: "+90 224 285 8585",
    website: "www.extrempark.com.tr",
    email: "info@extrempark.com.tr",
    isSponsored: true,
    isEditorPick: true,
    isOpen: true,
    description: "Dağ kızağı, dev salıncak, ipli parkurlar ve panoramik seyir terası. Avrupa standartlarında macera parkı.",
    longDescription: "Extrempark Bursa, Nilüfer ilçesindeki Atatürk Kent Ormanı içinde kurulu Türkiye'nin en kapsamlı macera parklarından biridir. Doğayla iç içe ormanlık alanda yer alan park; dağ kızağı, zipline, dev salıncak, asma köprü ve birden fazla zorlu ipli parkur ile misafirlerine adrenalin dolu bir gün yaşatmaktadır. Çocuklar için ayrı mini aktivite alanı da bulunmaktadır. Yeşilliklerle çevrili panoramik seyir noktasından Bursa ovasının muhteşem manzarası eşliğinde dinlenme imkânı da sunulmaktadır. Nisan-Kasım ayları arasında açık olan park, yaz tatillerinde yoğun ilgi görmektedir. Online bilet alımı ve erken rezervasyonda ekstra indirim imkânı mevcuttur.",
    tags: ["Macera", "Dağ Kızağı", "Aile", "Manzara", "Zipline"],
    lat: 40.22300,
    lng: 28.96850,
    openingHours: [
      { day: "Pazartesi", hours: "10:00 – 18:00", isOpen: true },
      { day: "Salı", hours: "10:00 – 18:00", isOpen: true },
      { day: "Çarşamba", hours: "10:00 – 18:00", isOpen: true },
      { day: "Perşembe", hours: "10:00 – 18:00", isOpen: true },
      { day: "Cuma", hours: "10:00 – 19:00", isOpen: true },
      { day: "Cumartesi", hours: "09:00 – 20:00", isOpen: true },
      { day: "Pazar", hours: "09:00 – 20:00", isOpen: true },
    ],
    priceRange: "₺₺₺",
    campaignId: "extrempark-30",
    relatedVenueIds: ["hayvanat-bahcesi", "bursa-teleferik", "uludag-milli-park", "bursa-panoramik"],
  },
  {
    id: "gumusçpala-termal",
    name: "Gümüşpala Termal Hotel",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.7,
    reviews: 892,
    distanceKm: 3.8,
    coverImage: "https://readdy.ai/api/search-image?query=luxury%20thermal%20spa%20hotel%20Bursa%20Cekirge%20elegant%20facade%20pool%20stone%20architecture%20wellness%20aerial%20panoramic%20dramatic%20warm%20golden%20hour&width=1400&height=600&seq=vd_gumuspala_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=thermal%20spa%20pool%20indoor%20luxury%20hotel%20Bursa%20Turkey%20warm%20water%20mineral%20bath%20serene%20elegant%20marble&width=800&height=600&seq=vd_gumuspala_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=luxury%20hotel%20room%20interior%20elegant%20furniture%20Bursa%20Turkey%20premium%20bedding%20warm%20decor%20modern%20classic&width=800&height=600&seq=vd_gumuspala_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=hotel%20restaurant%20fine%20dining%20Bursa%20Turkey%20elegant%20table%20setting%20candlelight%20premium%20cuisine%20interior&width=800&height=600&seq=vd_gumuspala_g3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Ottoman%20hammam%20Turkish%20bath%20marble%20hot%20stone%20spa%20traditional%20Bursa%20luxury%20wellness%20interior&width=800&height=600&seq=vd_gumuspala_g4&orientation=landscape",
    ],
    address: "Çekirge Cad. 1, Osmangazi, Bursa",
    district: "Osmangazi",
    phone: "+90 224 233 9310",
    website: "www.gumuspala.com.tr",
    email: "rezervasyon@gumuspala.com.tr",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Osmanlı hamamı estetiği, mineral zengini termal sular ve şehrin en prestijli restoran deneyimi.",
    longDescription: "Gümüşpala Termal Hotel, Bursa'nın dünyaca ünlü Çekirge termal bölgesinde yer alan 5 yıldızlı prestij otelidir. Doğal termal su kaynakları üzerine inşa edilmiş otel; iç ve dış havuzlar, Osmanlı hamamı, masaj ve spa merkezi ile misafirlerine eksiksiz bir wellness deneyimi sunmaktadır. Tarihi konumuna rağmen tamamen modern donanımlı olan otel, aynı zamanda Bursa'nın en iyi restoranlarından birine ev sahipliği yapmaktadır. 120 adet oda, konferans salonları ve özel etkinlik alanlarıyla iş ve tatil seyahatlerinde tercih edilen bir adres olmuştur. Rezervasyon yaptıran misafirlerimize ücretsiz airport transfer dahildir.",
    tags: ["Termal", "5 Yıldız", "Spa", "Restoran", "Hamam"],
    lat: 40.19231,
    lng: 29.03854,
    openingHours: [
      { day: "Pazartesi", hours: "24 Saat Açık", isOpen: true },
      { day: "Salı", hours: "24 Saat Açık", isOpen: true },
      { day: "Çarşamba", hours: "24 Saat Açık", isOpen: true },
      { day: "Perşembe", hours: "24 Saat Açık", isOpen: true },
      { day: "Cuma", hours: "24 Saat Açık", isOpen: true },
      { day: "Cumartesi", hours: "24 Saat Açık", isOpen: true },
      { day: "Pazar", hours: "24 Saat Açık", isOpen: true },
    ],
    priceRange: "₺₺₺₺",
    campaignId: "hotel-early",
    relatedVenueIds: ["kervansaray-termal", "boutique-1453", "hilton-bursa"],
  },
  {
    id: "bursa-teleferik",
    name: "Bursa Teleferik",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.7,
    reviews: 1450,
    distanceKm: 8.2,
    coverImage: "https://readdy.ai/api/search-image?query=cable%20car%20Uludag%20mountain%20Bursa%20Turkey%20aerial%20gondola%20panoramic%20view%20forest%20city%20below%20wide%20dramatic%20scenic%20landscape%20blue%20sky&width=1400&height=600&seq=vd_teleferik_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=cable%20car%20gondola%20interior%20mountain%20Bursa%20Turkey%20passengers%20view%20window%20nature%20aerial%20dramatic&width=800&height=600&seq=vd_teleferik_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Uludag%20mountain%20summit%20panoramic%20view%20Bursa%20Turkey%20forest%20snow%20winter%20cable%20car%20station&width=800&height=600&seq=vd_teleferik_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bursa%20city%20aerial%20view%20from%20cable%20car%20mountain%20height%20valley%20green%20plain%20panoramic%20dramatic%20sky&width=800&height=600&seq=vd_teleferik_g3&orientation=landscape",
    ],
    address: "Namazgah, Osmangazi, Bursa",
    district: "Osmangazi",
    phone: "+90 224 254 5060",
    website: "www.bursateleferik.com.tr",
    email: "",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Dünyanın en uzun teleferik hatlarından biri. Şehirden Uludağ zirvesine 8 dakikalık panoramik yolculuk.",
    longDescription: "Bursa Teleferik, şehir merkezini doğrudan Uludağ'a bağlayan ve dünyanın en uzun teleferik hatları arasında yer alan bir ulaşım ve turizm tesisidir. Toplam uzunluğu yaklaşık 8 km olan hat, üç durak ile şehirden 1500-2000 metre yüksekliğe çıkmaktadır. Gondoladan Bursa ovasının, Gemlik Körfezi'nin ve açık havalarda Marmara Denizi'nin muhteşem manzarası izlenebilmektedir. Yaz aylarında yürüyüş, kış aylarında kayak merkezi ulaşımı amacıyla yoğun kullanılan teleferik, hem yerel hem de ziyaretçi için vazgeçilmez bir deneyimdir. Günün her saatinde işleten teleferik, gece de çalışmaktadır.",
    tags: ["Teleferik", "Manzara", "Doğa", "Yaz/Kış", "Uludağ"],
    lat: 40.21023,
    lng: 29.06780,
    openingHours: [
      { day: "Pazartesi", hours: "08:00 – 22:00", isOpen: true },
      { day: "Salı", hours: "08:00 – 22:00", isOpen: true },
      { day: "Çarşamba", hours: "08:00 – 22:00", isOpen: true },
      { day: "Perşembe", hours: "08:00 – 22:00", isOpen: true },
      { day: "Cuma", hours: "08:00 – 23:00", isOpen: true },
      { day: "Cumartesi", hours: "08:00 – 23:00", isOpen: true },
      { day: "Pazar", hours: "08:00 – 22:00", isOpen: true },
    ],
    priceRange: "₺₺",
    campaignId: null,
    relatedVenueIds: ["uludag-milli-park", "extrempark", "bursa-panoramik", "botanik-park"],
  },
  {
    id: "cumalikizik-koy",
    name: "Cumalıkızık Köyü",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.9,
    reviews: 2580,
    distanceKm: 12.0,
    coverImage: "https://readdy.ai/api/search-image?query=Cumalikizik%20village%20Bursa%20Turkey%20UNESCO%20cobblestone%20narrow%20street%20stone%20Ottoman%20houses%20morning%20light%20charming%20ancient%20panoramic%20wide%20view&width=1400&height=600&seq=vd_cumalikizik_cover&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Cumalikizik%20Ottoman%20village%20stone%20house%20exterior%20colorful%20wooden%20windows%20Bursa%20Turkey%20ancient%20detail&width=800&height=600&seq=vd_cumalikizik_g1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cumalikizik%20village%20street%20cobblestone%20narrow%20alley%20locals%20morning%20Bursa%20Turkey%20ancient%20houses&width=800&height=600&seq=vd_cumalikizik_g2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=traditional%20Turkish%20breakfast%20spread%20village%20table%20Cumalikizik%20organic%20honey%20eggs%20cheese%20authentic%20morning&width=800&height=600&seq=vd_cumalikizik_g3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cumalikizik%20women%20craft%20pottery%20weaving%20traditional%20Turkish%20village%20culture%20heritage%20Bursa&width=800&height=600&seq=vd_cumalikizik_g4&orientation=landscape",
    ],
    address: "Cumalıkızık, Yıldırım, Bursa",
    district: "Yıldırım",
    phone: "",
    website: "",
    email: "",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "UNESCO Dünya Mirası. 700 yıllık taş evler, dar sokaklar ve geleneksel yaşam. Fotoğraf tutkunlarının başucu yeri.",
    longDescription: "Cumalıkızık, Bursa'ya yaklaşık 12 km uzaklıkta ve Uludağ eteklerinde yer alan 700 yıllık bir Osmanlı köyüdür. Tarihi dokusuyla UNESCO Dünya Mirası Listesi'nde yer alan köy; dar taş sokakları, ahşap cumbalı evleri ve kırsal yaşam tarzıyla ziyaretçilere geçmişe yolculuk yaptırmaktadır. Köyde gezilecek pek çok tarihi yapı, küçük dükkanlar, el sanatları atölyeleri ve organik ürün satan yerel üreticiler bulunmaktadır. Hafta sonlarına özel kurulan köy pazarı ve taş binalardaki geleneksel kahvaltı mekânları büyük ilgi görmektedir. Gün doğumunda köyü gezmek özellikle tavsiye edilmektedir.",
    tags: ["UNESCO", "Köy", "Fotoğraf", "Kahvaltı", "Osmanlı"],
    lat: 40.17215,
    lng: 29.12341,
    openingHours: [
      { day: "Pazartesi", hours: "Tüm Gün Açık", isOpen: true },
      { day: "Salı", hours: "Tüm Gün Açık", isOpen: true },
      { day: "Çarşamba", hours: "Tüm Gün Açık", isOpen: true },
      { day: "Perşembe", hours: "Tüm Gün Açık", isOpen: true },
      { day: "Cuma", hours: "Tüm Gün Açık", isOpen: true },
      { day: "Cumartesi", hours: "Tüm Gün Açık", isOpen: true },
      { day: "Pazar", hours: "Tüm Gün Açık", isOpen: true },
    ],
    priceRange: "Ücretsiz",
    campaignId: "cumalikizik-2plus1",
    relatedVenueIds: ["cumalikizik-sofrasi", "cumalikizik-butik", "golyazi", "bursa-muzesi"],
  },
];
